export default "__VITE_ASSET__CDCC8kIE__"